type RowRenderProbe = (rendered: boolean) => void;

let probe: RowRenderProbe | null = null;

/**
 * Registers the listener `DataTable` reports each body row to: `true` when the row rendered, `false` when its memo
 * skipped it. `null` detaches. Keeps `ui/` free of app imports; the app wires the flight recorder in debug mode.
 */
export function setRowRenderProbe(next: RowRenderProbe | null): void {
  probe = next;
}

/** Reports one row to the registered probe, if any. */
export function probeRow(rendered: boolean): void {
  probe?.(rendered);
}
